import { IStackItemStyles } from 'office-ui-fabric-react';


export const styleLocationsPage: IStackItemStyles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
        height: '100vh'
    }
};

export const styleLocationTree: IStackItemStyles = {
    root: {
        flexBasis: '30%',
        boxSizing: 'border-box',
        padding: '1rem',
        overflowY: 'auto'
    }
};

export const styleLocationInfo: IStackItemStyles = {
    root: {
        flexBasis: '70%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        marginLeft: '2vh'
    }
};
